<template>
  <div class="distributor-box">
    <!--功能按钮操作区域-->
    <div class="operation-box" v-if="getPermission('role_insert')">
      <Button type="primary" @click="addRoleBtn">{{ $t('key1005849') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        highlight-row
        border
        max-height="650"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="pageTableData">
      </Table>
    </div>
    <Page
      :transfer="true"
      v-if="!tableLoading"
      class="distributor-page-box"
      :total="tableData.length"
      :current="pageParams.pageNum"
      :page-size="pageParams.pageSize"
      show-total
      show-sizer
      show-elevator
      placement="top"
      @on-change="localChangePage"
      @on-page-size-change="localChangePageSize"
      :page-size-opts="pageArray"/>
    <!--查看用户弹窗-->
    <viewUsersModal :roleList="tableData" ref="viewUsers"></viewUsersModal>
    <!--新增、编辑、查看角色弹窗-->
    <editRoleModal ref="editRole" @updateData="getRoleList()"></editRoleModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import viewUsersModal from "@/views/distributor/components/permissionManage/viewUsersModal";
import editRoleModal from "@/views/distributor/components/permissionManage/editRoleModal";
import {isAlibabaDistributor} from "@/utils/common";

export default {
  name: "roleManage",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005842'),
          key: 'roleName',
          align: 'left',
          minWidth: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005843'),
          key: 'remark',
          align: 'left',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005844'),
          key: 'userNumber',
          align: 'left',
          minWidth: 130,
          render(h, params) {
            let list = params.row.userInfoList || [];
            list.map((item) => {
              item.status = Number(item.status);
              item.roleName = params.row.roleName;
            });
            let newList = list.filter((item) => {
              return item.status === 1;
            });
            return h('Alink', {
              props: {
                linkName: newList.length,
                textAlign: 'left'
              },
              on: {
                AlinkBtn: () => {
                  v.$refs['viewUsers'].initFun(list);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          width: 200,
          renderHeader(h, params) {
            return h('div', {class: 'flex align-items-center'}, [
              h('span', {class: 'mr5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319')),
              h('Tooltip', {
                props: {
                  transfer: true,
                  maxWidth: 250,
                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005845'),
                  placement: 'left'
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    size: 17,
                    color: isAlibabaDistributor() ? '#2D8CF0' : '#FD5425'
                  },
                  style: {
                    cursor: 'pointer'
                  }
                })
              ])
            ]);
          },
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$refs['editRole'].initFun('look', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('role_update'),
                    clickFn: () => {
                      v.$refs['editRole'].initFun('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('role_delete'),
                    color: '#FF0000',
                    clickFn: () => {
                      v.deleteRoleBtn(params.row.roleId);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      pageParams: {
        pageNum: 1,
        pageSize: 100,
      },
    };
  },
  created() {
    this.getRoleList();
  },
  computed: {
    pageTableData() {
      let start = (this.pageParams.pageNum - 1) * this.pageParams.pageSize;
      let end = (this.pageParams.pageNum - 1) * this.pageParams.pageSize + this.pageParams.pageSize;
      this.tableLoading = false;
      return this.tableData.slice(start, end);
    }
  },
  methods: {
    // 获取所有角色数据
    getRoleList() {
      let v = this;
      v.tableData = [];
      if (v.getPermission('role_query')) {
        v.axios.post(api.post_role_query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            v.tableData = data;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 添加角色
    addRoleBtn() {
      this.$refs['editRole'].initFun('add', null);
    },
    // 删除角色
    deleteRoleBtn(roleId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005846'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005847'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.delete(api.delete_role + roleId, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005848'));
              v.getRoleList();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    localChangePage(page) {
      let v = this;
      v.pageParams.pageNum = page;
    },
    localChangePageSize(pageSize) {
      this.pageParams.pageSize = pageSize;
      this.tableLoading = true;
      this.setPageSizeStorage(pageSize);
    },
  },
  components: {
    viewUsersModal,
    editRoleModal
  }
};
</script>

<style scoped>

</style>
